module.exports = __webpack_public_path__ + "static/media/model3.71b424fc.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/model3.jpeg
// module id = 47
// module chunks = 0